module.exports = __webpack_public_path__ + "img/envelop_icon.96c72d88.svg";